import { render, staticRenderFns } from "./prohibit.vue?vue&type=template&id=a7d29de0&"
import script from "./prohibit.vue?vue&type=script&lang=js&"
export * from "./prohibit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports